module.exports = require("sanitize-html");


//////////////////
// WEBPACK FOOTER
// external "sanitize-html"
// module id = 604
// module chunks = 0